const request = {
    invalid_input: "L'entrée est invalide. {{details}}",
    general: "Une erreur de requête s'est produite.",
    /** UNTRANSLATED */
    range_not_satisfiable: 'Range not satisfiable.',
};
export default Object.freeze(request);
